import { Device } from '@capacitor/device'

let cachedId = null

export const DeviceService = {
	async getInfo() {
		return await Device.getInfo()
	},

	async getId() {
		if (!cachedId) {
			const id = await Device.getId()
			cachedId = id.identifier
		}
		return cachedId
	}
}
